// ----------------------------------------------------------------------------
// Snippet: Gift Card Recipient's Form
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------

// Styles
import './_gift-card-recipient-form.scss';

if (!customElements.get('recipient-form')) {
    customElements.define('recipient-form', class RecipientForm extends HTMLElement {
        constructor() {
            super();
            this.checkboxInput = this.querySelector(`#Recipient-checkbox-${this.dataset.sectionId}`);
            this.checkboxInput.disabled = false;
            this.recipientFields = this.querySelector(`#Recipient-fields-${this.dataset.sectionId}`);
            this.emailInput = this.querySelector(`#Recipient-email-${this.dataset.sectionId}`);
            this.nameInput = this.querySelector(`#Recipient-name-${this.dataset.sectionId}`);
            this.messageInput = this.querySelector(`#Recipient-message-${this.dataset.sectionId}`);
            this.sendonInput = this.querySelector(`#Recipient-send-on-${this.dataset.sectionId}`);
    
            this.restrictDate();
            this.addEventListener('change', this.onChange.bind(this));
            this.onChange();
        }
        
        onChange() {
            if (this.checkboxInput.checked) {
                this.checkboxInput.setAttribute('aria-expanded', true);
                this.recipientFields.hidden = false;
                this.checkboxInput.value = 'true';
                this.enableInputFields();
            } else {
                this.checkboxInput.setAttribute('aria-expanded', false);
                this.recipientFields.hidden = true;
                this.checkboxInput.value = 'false'
                this.disableInputFields();
            }
        }
        
        inputFields() {
            return [this.emailInput, this.nameInput, this.messageInput, this.sendonInput];
        }
        
        enableInputFields() {
            this.inputFields().forEach((field) => (field.disabled = false));
        }

        disableInputFields() {
            this.inputFields().forEach((field) => (field.disabled = true));
        }
        
        restrictDate() {
            // Get today's date
            let today = new Date();
            const dd = String(today.getDate()).padStart(2, '0');
            const mm = String(today.getMonth() + 1).padStart(2, '0');
            const yyyy = today.getFullYear();

            today = yyyy + '-' + mm + '-' + dd;

            // Set the minimum date for the input field
            this.sendonInput.setAttribute("min", today);
        }
    });
}

